<template>
	<div class="container">
		<myheader name="核心业务"></myheader>
		<div class="core-banner minwidth vcenter">
			<div class="banner-text">
				<div class="text1">构建艺术品资产化的 完整生态</div>
				<div class="text2">
					<p>
						我们提供从物理世界的“确真确权”，到数字世界的“科学确价”
					</p>
					<p>
						再到市场流通的“价值服务”的全链路解决方案
					</p>
				</div>
			</div>

			<div class="prgs-box align-c">
				<div class="prgs-li vcenter">
					<div class="li-num">
						01
					</div>
					<div class="t1">鉴证备案</div>
					<div class="t2">物理身份备案</div>
				</div>
				<div class="prgs-arrow">
					<img class="prgs-img" src="@/static/new/core_banner_arrow.png" alt="">
				</div>
				<div class="prgs-li vcenter">
					<div class="li-num">
						02
					</div>
					<div class="t1">价值评估</div>
					<div class="t2">数字价值发现</div>
				</div>
				<div class="prgs-arrow">
					<img class="prgs-img" src="@/static/new/core_banner_arrow.png" alt="">
				</div>
				<div class="prgs-li vcenter">
					<div class="li-num">
						03
					</div>
					<div class="t1">动产服务</div>
					<div class="t2">市场价值流转</div>
				</div>
			</div>
		</div>
		<div class="mx1360 flex-c-c-c">
			<div class="list">
				<div v-for="(v, k) in list" class="list-li" :key="k">
					<template v-if="k % 2 == 0">
						<div class="img-box">
							<img class="ls-img cover" :src="v.fileList[0].url" alt="">
						</div>
						<div class="info-box">
							<div class="section-name">SERVICE {{ String((Number(k) + 1)).padStart(2, 0) }}</div>
							<div class="li-title">{{ v.title || "" }}</div>
							<div class="des">
								{{ v.description || "" }}
							</div>
							<div class="pr-list" v-html="v.content"></div>

							<div class="link-box-outer">
								<div @click="goPage(v)" class="link-box curadm vcenter">{{ v.subtitle || '' }}</div>
							</div>
						</div>
					</template>
					<template v-else>

						<div class="info-box box2">
							<div class="section-name">SERVICE {{ String((Number(k) + 1)).padStart(2, 0) }}</div>
							<div class="li-title">{{ v.title || "" }}</div>
							<div class="des">
								{{ v.description || "" }}
							</div>
							<div class="pr-list" v-html="v.content"></div>

							<div class="link-box-outer">
								<div @click="goPage(v)" class="link-box curadm vcenter">{{ v.subtitle || '' }}</div>
							</div>
						</div>
						<div class="img-box">
							<img class="ls-img cover" :src="v.fileList[0].url" alt="">
						</div>
					</template>
				</div>
			</div>

		</div>
		<myfooter></myfooter>

	</div>

</template>
<script>
let that;
import ty from "@/utils/ty/ty";
import util from "@/common/util.js";
export default {
	name: "CoreBusiness",
	data() {
		return {
			list: []
		}
	},
	mounted() {
		that = this;
		that.initData();
	},
	methods: {
		goPage(v) {
			let newsid = ''
			if (v.id == 9) {
				newsid = 38;
			} else if (v.id == 10) {
				newsid = 39;
			} else if (v.id == 11) {
				newsid = 40;

			}
			util.tourl("/detail", { id: newsid, lm: "核心业务" })
		},
		initData() {
			ty.ajax('web/web/business', {}).then((result) => {
				that.list = result.data.data
			});
		}
	},
}
</script>
<style lang="scss" scoped>
@import '../style.scss'; //所有页面公用
@import '../style2.scss'; //所有页面公用
@import './coreBusiness.scss';
</style>